import React from 'react'

import { ContentBlock } from 'components/ContentBlock'
import CashRegistersTree from 'components/CashRegisterTree'
import get from 'helpers/get'
import { useMutation } from 'components/graphql'
import { updateCreditClient } from '../gql'

const CashRegister = ({ data }) => {
	const [updateCashRegisters] = useMutation(updateCreditClient.cashRegisters)
	const kasseIdArr = get(['cashRegisterId'], data)
	const handleUpdateCashRegisters = newKasseIdArr => {
		updateCashRegisters({
			variables: {
				id: data.id,
				fields: {
					cashRegisterId: newKasseIdArr
				}
			}
		})
	}

	return(
		<ContentBlock>
			<CashRegistersTree activeNodesArr={kasseIdArr} onChange={handleUpdateCashRegisters}/>
		</ContentBlock>
	)
}

export default CashRegister
